module.exports = __webpack_public_path__ + "static/media/arrow-down.a3c2b65e.svg";